
  var _styles = {
  "comprehensive-card-container": {
    "width": "9.36rem",
    "padding": "0.32rem",
    "margin": "auto",
    "marginBottom": "0.16rem",
    "borderRadius": "0.2rem",
    "backgroundColor": "rgb(255,255,255)",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "stretch"
  },
  "comprehensive-card-right-container": {
    "marginLeft": "0.32rem"
  },
  "comprehensive-card-location": {
    "width": "5.89333rem",
    "marginTop": "0.16rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(102,102,102)",
    "letterSpacing": 0,
    "lineHeight": "0.36rem"
  }
};



  module.exports = _styles;
  